var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'acceptance-mode': _vm.acceptance },attrs:{"id":"app"}},[(_vm.acceptance)?_c('div',{staticClass:"acceptance-notice"},[_vm._v(_vm._s(_vm.environmentNotice))]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }